import { render, staticRenderFns } from "./VTD.vue?vue&type=template&id=ad3b0722"
import script from "./VTD.vue?vue&type=script&lang=js"
export * from "./VTD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports